class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.gallerySlider = this.querySelector('.gallery-zoom-slider');
    this.zoomSlides = this.querySelectorAll('.slider-slide-zoom');
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = false;
    this.isInteractedWith = false;
    this.innerOverlayTriggers = this.querySelectorAll('[data-inner-overlay-trigger]');

    if (this.dataset.isZoomable === 'true') {
      this.isZoomable = true;
      this.isZoomedIn = false;
      this.zoomSlides.forEach((slide) => slide.addEventListener('click', this.zoomSlideClick.bind(this)));
    }

    //? Update slide count
    this.currentSlideEl = this.querySelector('[data-current-slide]');
    this.totalSlideEl = this.querySelector('[data-total-slide]');

    //? Slide thumbnails
    this.nextSlideThumbnail = this.querySelector('[data-next-slide-thumbnail]');
    this.prevSlideThumbnail = this.querySelector('[data-prev-slide-thumbnail]');

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');

    if (this.totalAmountOfSlides.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    this.cursorText = document.getElementById('cursor-text');

    const linkToSlideButtonList = document.querySelectorAll('.link-to-slide-button');
    if (linkToSlideButtonList) {
      linkToSlideButtonList.forEach((link) =>
        link.addEventListener('click', this.linkToSlideFromOutsideButton.bind(this))
      );
    }

    if (this.currentSlideEl) {
      this.currentSlideEl.textContent = this.currentPage;
    }

    if (this.totalSlideEl) {
      const slides = this.querySelectorAll('.slideshow__slide');
      this.totalSlideEl.textContent = slides.length;
    }

    if (this.innerOverlayTriggers && this.innerOverlayTriggers.length > 0) {
      this.innerOverlayTriggers.forEach((trigger) => {
        if (trigger.dataset.target.includes(`id-${this.currentPage}`)) {
          trigger.dataset.isVisible = 'true';
        }
      });
    }

    if (this.nextSlideThumbnail) {
      this.slideImages = this.querySelectorAll('[data-slides] img');
      this.updateThumbnail();
    }

    if (this.cursorText) {
      this.handleCursorText();
    }
  }

  updateThumbnail(nextSlideIndex, prevSlideIndex) {
    this.updateThumbnailAttr(this.nextSlideThumbnail.querySelector('img'), this.slideImages[nextSlideIndex]);
    this.updateThumbnailAttr(this.prevSlideThumbnail.querySelector('img'), this.slideImages[prevSlideIndex]);
  }

  updateThumbnailAttr(currentEl, nextEl) {
    if (!currentEl || !nextEl) return;
    currentEl.srcset = nextEl.src;
    currentEl.src = nextEl.src;
    currentEl.alt = nextEl.alt;
  }

  //? This method will position the cursorText element next to the cursor when the user hovers over the prev and next buttons
  //? The content will update
  handleCursorText() {
    const updateCursorTextPosition = (event) => {
      if (this.isZoomable) {
        this.cursorText.style.transform = `translate(${event.pageX - 12}px, ${event.pageY - 8}px)`;
      } else {
        this.cursorText.style.transform = `translate(${event.pageX - 50}px, ${event.pageY}px)`;
      }
    };

    const showCursorIcon = (iconHTML) => {
      this.cursorText.innerHTML = iconHTML;
      this.cursorText.style.opacity = 1;
      this.addEventListener('mousemove', updateCursorTextPosition);
    };

    const hideCursorText = () => {
      this.cursorText.style.opacity = 0;
      this.removeEventListener('mousemove', updateCursorTextPosition);
    };

    const showCursorZoomText = () => {
      this.cursorText.innerHTML = 'Zoom in';
      this.cursorText.style.opacity = 1;
      this.addEventListener('mousemove', updateCursorTextPosition);
    };

    if (this.isZoomable) {
      // Init
      showCursorZoomText();

      this.gallerySlider.addEventListener('mouseenter', showCursorZoomText);
      this.gallerySlider.addEventListener('mouseleave', hideCursorText);
    }
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');

    if (this.currentSlideEl) {
      this.currentSlideEl.textContent = this.currentPage;
    }

    if (this.innerOverlayTriggers && this.innerOverlayTriggers.length > 0) {
      this.innerOverlayTriggers.forEach((trigger) => {
        trigger.dataset.isVisible = 'false';

        if (trigger.dataset.target.includes(`id-${this.currentPage}`)) {
          trigger.dataset.isVisible = 'true';
        }
      });
    }

    if (this.nextSlideThumbnail) {
      const nextSlideIndex = this.currentPage === this.totalAmountOfSlides.length ? 0 : this.currentPage;
      const prevSlideIndex = this.currentPage === 1 ? this.totalAmountOfSlides.length - 1 : this.currentPage - 2;

      this.updateThumbnail(nextSlideIndex, prevSlideIndex);
    }

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling() {
    this.play();
  }

  focusInHandling() {
    this.pause();
  }

  play() {
    if (this.isInteractedWith) return;

    this.slider.setAttribute('aria-live', 'off');
    const isScrolledToTheEnd = this.slider.scrollLeft + 1 <= this.slider.scrollWidth - this.slider.clientWidth;
    if (isScrolledToTheEnd) this.slider.scrollLeft += 1 * 1;
    this.animationFrameId = requestAnimationFrame(() => this.play());
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }
  }

  stop() {
    this.isInteractedWith = true;
    this.slider.setAttribute('data-autoplay', 'false');
    this.pause();
  }

  setAutoPlay() {
    let hasBeenInView = false;

    //? Start scrolling the slider when it's in view
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (!hasBeenInView) {
              hasBeenInView = true;
              this.initializeAutoPlay();
            }
            this.play();
          } else {
            this.pause();
          }
        });
      },
      {
        root: null,
        rootMargin: '150px',
        threshold: 0.5,
      }
    );

    observer.observe(this);
  }

  initializeAutoPlay() {
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.slider.addEventListener('mousedown', this.stop.bind(this));
    this.slider.addEventListener('touchstart', this.stop.bind(this));
    this.slider.addEventListener('wheel', this.handleWheel.bind(this));

    this.prevButton.addEventListener('click', this.stop.bind(this));
    this.nextButton.addEventListener('click', this.stop.bind(this));

    this.slider.addEventListener('mouseover', this.stop.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
    }
  }

  //? Prevent scrolling when the user is trying to scroll horizontally
  handleWheel(event) {
    if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
      this.stop();
    }
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  setSlideVisibility() {
    this.totalAmountOfSlides.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  linkToSlideFromOutsideButton(event) {
    event.preventDefault();
    const index = event.currentTarget.dataset.index;
    const slideScrollPosition = this.sliderFirstItemNode.clientWidth * index;
    this.slider.scrollTo({
      left: slideScrollPosition,
      behavior: 'instant',
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);

    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  zoomSlideClick(slide) {
    this.isZoomedIn = !this.isZoomedIn;
    this.gallerySlider.classList.toggle('gallery-zoom-slider--zoom-out');

    if (this.isZoomedIn) {
      this.cursorText.innerHTML = 'Zoom out';
    } else {
      this.cursorText.innerHTML = 'Zoom in';
    }
  }
}

customElements.define('slideshow-component', SlideshowComponent);
